import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function PharmacistConsultation() {
  return <div className="flex h-full flex-col rounded-xl border border-blue-200 bg-blue-50 p-3 shadow-sm" data-id="element-4965" data-mp="3933lko2gg0sf">
      <div className="mb-3 flex items-start gap-2" data-id="element-4966" data-mp="2ueqp7pzggfxe">
        <div className="shrink-0 rounded-full bg-white p-1.5" data-id="element-4967" data-mp="2uc4g3lwx1sd2">
          <MessageCircleIcon className="h-4 w-4 text-blue-600" data-id="element-4968" data-mp="2zdtunbjcko5w" />
        </div>
        <div data-id="element-4969" data-mp="3n2d3bs6b72yi">
          <h3 className="text-sm font-bold leading-snug text-gray-900" data-id="element-4970" data-mp="3n3xwpegw0fus">Need help?</h3>
          <p className="mt-1 text-xs leading-snug text-gray-700" data-id="element-4971" data-mp="3s1zc9pf3tx1i">Ask a pharmacist for advice.</p>
        </div>
      </div>
      <button className="mt-auto flex w-full items-center justify-center gap-1.5 rounded-lg bg-blue-600 px-2 py-2 text-xs font-bold text-white transition-colors duration-150 hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2" data-id="element-4972" data-mp="3d3x9vijt7hlu">
        <MessageCircleIcon className="h-4 w-4" data-id="element-4973" data-mp="26pxzwcdc96br" />
        Ask pharmacist
      </button>
    </div>;
}